import { addTypesquareForNingen } from "./_add_typesquare";
import { IS_DEBUG } from "./_constants";

const {$}=window;

$(()=>{
  if(IS_DEBUG){
    const regexOkamura= /okamura\.co\.jp/;
    if(!document.location.href.match(regexOkamura)){
      addTypesquareForNingen();
    }
  }
  $(".p-section-hero__badge").click((event:{preventDefault:()=>void,currentTarget:HTMLAnchorElement})=>{
    event.preventDefault();
    const target=$(event.currentTarget).attr("href");
    const position=$(target).offset().top;
    const duration=500;
    $("html,body").animate({scrollTop:position},duration);
  });
  $(".p-section-credits__go-top").click((event:{preventDefault:()=>void})=>{
    event.preventDefault();
    const position=0;
    const duration=500;
    $("html,body").animate({scrollTop:position},duration);
  });

  $(".p-section-performers__slick").slick({
    infinite:true,
    // adaptiveHeight:true,
    centerMode: true,
    variableWidth: true,
    arrows:true,
    dots:true,
    slidesToShow: 1,
  });

  $(".p-section-report__slick").slick({
    infinite:true,
    // adaptiveHeight:true,
    centerMode: true,
    variableWidth: true,
    arrows:true,
    dots:true,
    slidesToShow: 1,
  });
  
});

